/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { APIProvider, Map, Marker, InfoWindow, AdvancedMarker, Pin, useMap } from '@vis.gl/react-google-maps';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Avatar from './Avatar'; // Adjust the folder path if necessary
import { useStateContext } from '../contexts/ContextProvider';
import zackatPin from '../data/mappin.png';
import googleMap from '../data/google-maps.png';
import './Map.css';

const spreadSameCoordinates = (list) => {
  const groups = {};
  list.forEach((marker) => {
    const key = `${Number(marker.lat).toFixed(5)},${Number(marker.lng).toFixed(5)}`;
    if (!groups[key]) groups[key] = [];
    groups[key].push(marker);
  });
  return list.map((marker) => {
    const key = `${Number(marker.lat).toFixed(5)},${Number(marker.lng).toFixed(5)}`;
    const group = groups[key];
    if (!group || group.length < 2) {
      return { ...marker, offsetX: 0, offsetY: 0 };
    }
    const index = group.indexOf(marker);
    const count = group.length;
    const radius = 36 / Math.sin(Math.PI / count);
    const angle = ((2 * Math.PI * index) / count) - (Math.PI / 2);
    return {
      ...marker,
      offsetX: Math.round(Math.cos(angle) * radius),
      offsetY: Math.round(Math.sin(angle) * radius),
    };
  });
};

export default function AMap({ active, org, frequency, refreshMs = 30000 }) {
  const [data, setData] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [refreshData, setRefreshData] = useState(true);
  const [locateData, setLocations] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [markers, setMarker] = useState([]);
  const { REACT_APP_API_ENDPOINT } = process.env;
  let { REACT_APP_GOOGLE_MAPS_API_KEY } = process.env;
  const { REACT_APP_GOOGLE_MAPS_API_KEY_DEV } = process.env;
  const { REACT_APP_ENV } = process.env;
  const { REACT_APP_GOOGLE_MAPS_ID } = process.env;
  if (!REACT_APP_ENV || REACT_APP_ENV === '') {
    REACT_APP_GOOGLE_MAPS_API_KEY = REACT_APP_GOOGLE_MAPS_API_KEY_DEV;
  }
  let days = 7;
  if (frequency === 'day') {
    days = 1;
  } else if (frequency === 'week') {
    days = 7;
  } else if (frequency === 'month') {
    days = 30;
  } else if (frequency === 'year') {
    days = 365;
  }

  const { amapActive, setAmapActive } = useStateContext();
  const [activeMarker, setActiveMarker] = useState(null);

  // Separate component inside APIProvider to access the map instance via hook
  const MapBoundsFitter = ({ markers }) => {
    const map = useMap();

    useEffect(() => {
      if (!map || markers.length === 0) return;

      // Create a new boundary box
      const bounds = new window.google.maps.LatLngBounds();

      // Extend the boundaries to include each marker's position
      markers.forEach((marker) => {
        bounds.extend({ lat: marker.lat, lng: marker.lng });
      });

      // Adjust map zoom and center to fit the boundary box
      map.fitBounds(bounds);
      // Get the exact center coordinate point of the bounds
      const centerLatLng = bounds.getCenter();

      map.setCenter(centerLatLng);
    }, [map, markers]);

    return null; // This component handles side effects, no UI needed
  };
  const handleActiveMarker = (marker) => {
    setInfoWindowShown((isShown) => !isShown);
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };
  const timerid = useRef();
  let map;
  const usr = JSON.parse(localStorage.getItem('user'));
  const selectedOrg = JSON.parse(localStorage.getItem('organization'));
  if (selectedOrg && usr) {
    usr.organizationid = selectedOrg.id;
  }
  const [defcenter, setDefaultCenter] = useState({});
  let initialMarkers = [];

  async function getData() {
    const loc = window.location;
    // if (loc.pathname !== '/associates' && loc.pathname !== '/associate') {
    //  timerid.current = clearInterval(timerid.current);
    // }
    usr.limit = '1000';
    if (active && org) {
      usr.organizationid = org;
      usr.specific = true;
    }
    const query = Object.entries(usr)
      .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
      .join('&');
    if (timerid.current) {
      await axios({
        url: `${REACT_APP_API_ENDPOINT}/associates?${query}`,
        method: 'get',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          setData(response.data);
          initialMarkers = [];
          if (response.data && response.data.associates) {
            response.data.associates.map((event) => {
              // const exists = checkMarker(event);
              const reported = new Date(event.latlng && event.latlng.timestamp).getTime();
              const age = Date.now() - reported;
              if (!event.latlng || Number.isNaN(reported) || age > days * 24 * 60 * 60 * 1000) {
                event = null;
              }
              if (event && event.latlng && event.latlng.latitude !== 0 && event.latlng.longitude !== 0) {
                const marker = {
                  lat: event.latlng.latitude,
                  lng: event.latlng.longitude,
                  title: event.name,
                  device: event.device,
                  _id: event._id,
                  info: `Title: ${event.jobtask}`,
                  image: event.employeeImage,
                };
                initialMarkers.push(marker);
              }
            });
            // timerid.current = setInterval(getData, 30000);
            if (timerid.current && !amapActive) {
              clearInterval(timerid.current);
              timerid.current = null;
            }
            if (initialMarkers.length > 0) {
              const spaced = spreadSameCoordinates(initialMarkers);
              setMarker(spaced);
              const center = { lat: Number(spaced[0].lat), lng: Number(spaced[0].lng) };
              setDefaultCenter(center);
              setLoadingData(false);
            }
          }
        })
        .catch((error) => console.error(error));
    }
  }
  useEffect(() => {
    if (active) {
      setLocations(active);
      setAmapActive(active);
    }
    return () => {
      setAmapActive(false);
    };
  }, []);
  useEffect(() => {
    if (timerid.current && !amapActive) {
      clearInterval(timerid.current);
      timerid.current = null;
    } else if (!timerid.current && amapActive) {
      timerid.current = setInterval(getData, refreshMs);
    }
    return () => {
      timerid.current = clearInterval(timerid.current);
    };
  }, [amapActive, refreshMs]);
  // This will run one time after the component mounts
  useEffect(() => {
    // callback function to call when event triggers
    const onPageLoad = () => {
      timerid.current = setInterval(getData, refreshMs);
      setTimeout(getData, 500);
    };

    // Check if the page has already loaded
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      // Remove the event listener when component unmounts
      timerid.current = clearInterval(timerid.current);
      return () => window.removeEventListener('load', onPageLoad);
    }
  }, []);

  if (loadingData && !refreshData) {
    return <p>Loading... </p>;
  }
  const [infoWindowShown, setInfoWindowShown] = useState(false);

  // if the maps api closes the infowindow, we have to synchronize our state
  const handleClose = useCallback(() => setInfoWindowShown(false), []);
  const currentThemeColor = localStorage.getItem('colorMode');

  return (
    <div style={{
      backgroundColor: currentThemeColor,
      textAlign: 'right',
      marginTop: '-40px',
    }}
    >
      <button
        className="button"
        type="button"
        style={{
          borderWidth: 1,
          borderColor: 'rgba(0,0,0,0.2)',
          alignItems: 'center',
          justifyContent: 'center',
          width: 30,
          height: 30,
          borderRadius: 100,
        }}
        onClick={() => { setLocations(!locateData); setAmapActive(!amapActive); }}
      >
        <img src={googleMap} alt="map" />
      </button>
      <APIProvider
        apiKey={`${REACT_APP_GOOGLE_MAPS_API_KEY}`}
      >
        {locateData && !loadingData && (
          <div className="my-custom-map-wrapper">
            <Map
              style={{ width: '100%', height: '100%' }}
              defaultCenter={defcenter}
              mapId={`${REACT_APP_GOOGLE_MAPS_ID}`}
              defaultZoom={10}
              onClick={() => setActiveMarker(null)}
            >
              {markers.map((marker) => (
                <AdvancedMarker
                  className="bounce"
                  key={marker._id}
                  onClick={() => handleActiveMarker(marker)}
                  position={marker}
                >
                  <div style={{ transform: `translate(${marker.offsetX || 0}px, ${marker.offsetY || 0}px)` }}>
                    {marker && marker.title && marker.title.length > 0 && (
                      <Avatar name={`${marker.title}`} size={40} />
                    )}
                    {(!marker || !marker.title || marker.title.length === 0) && (
                      <img src={zackatPin} width="60px" height="60px" alt="" />
                    )}
                  </div>
                  {infoWindowShown && activeMarker && (
                  <InfoWindow
                    position={activeMarker}
                    onClose={() => handleClose()}
                  >
                    <h2>Device: {activeMarker.device}</h2>
                    <p>{activeMarker.info}</p>
                    <div>
                      <h1>{activeMarker && activeMarker.title ? activeMarker.title : ''}</h1>
                    </div>
                  </InfoWindow>
                  )}
                </AdvancedMarker>
              ))}
              <MapBoundsFitter markers={markers} />
            </Map>
          </div>
        )}
      </APIProvider>
    </div>
  );
}
